//Browser and version warning
export const BROWSER_WARNING = 'browserWarning';
export const VERSION_WARNING = 'versionWarning';
